import { SELF_SERVICE_PLANS, USER_ACCESS } from "@/constants";
import { FeatureType } from "@/features";
import { useOrganization } from "@/hooks/useOrganization";
import { useUser } from "@/hooks/useUser";

import { useFeatures } from "./useFeatures";

export const useMayBeUpsold = (required: FeatureType) => {
  const { data: featureData } = useFeatures();
  const { data: orgData } = useOrganization();
  const plan = orgData?.ok ? orgData.data.plan : null;
  const { data: user } = useUser();

  if (!plan || !featureData?.ok || !user?.ok) return;

  const user_type = user.data.user_type;
  const isSelfService = SELF_SERVICE_PLANS.includes(plan?.type);
  const features = featureData.data;

  // only orgs on self-service plans can be upsold
  if (!isSelfService) return false;

  // If the user has the feature, they don't need to be upsold
  if (features.user[required]) return false;

  // If the org has the feature, the user doesn't need to be upsold
  const orgHasFeature = features.organization[required] === true;
  if (orgHasFeature) return false;

  // Readonly users can't be upsold
  if (user_type === USER_ACCESS.READONLY) return false;

  return true;
};
